// extracted by mini-css-extract-plugin
export default {"options":"RadioAnswer_options__oIa10","selected":"RadioAnswer_selected__iJAEj"};